/**
 * ✅ Migrated to authStore_v1 - 2026-01-07
 * Uses authStore_v1 as single source of truth for token
 */

import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from "@apollo/client";
import { env } from "@/config/env";

const httpLink = new HttpLink({
  uri: env.GRAPHQL_ENDPOINT,
});

const authLink = new ApolloLink((operation, forward) => {
  // Read token from store (set by App.tsx from cookie)
  const { useAuthStoreV1 } = require("@/stores/authStore_v1");
  const token = useAuthStoreV1.getState().token;
  
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  }));
  return forward(operation);
});

export const apollo = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
